<template>
  <div class="modal" :class="{ open_modal: showModal }" data-modal="modal">
    <div class="modal_overlay" data-modal-close="modal"></div>
    <div class="modal_wrap">
      <div class="modal_header">
        <div class="d_flex_btwn">
          <h3>Shifts for {{ userData?.name }}</h3>
          <span>
            <span
              data-modal-close="modal"
              class="close_icon close_icon_md"
              @click.prevent="closeModal"
            ></span>
          </span>
        </div>
      </div>
      <div class="modal_inner">
        <div class="modal_content modal_1050p">
          <div class="row">
            <div class="col_12">
              <shift-assign-calender :user_id="userData?.id" :shifts="shifts" />
            </div>
            <div class="col_12">
              <shift-table-component :show="true" :shifts="shifts" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ShiftAssignCalender from './ShiftAssignCalender.vue';
import ShiftTableComponent from './ShiftTableComponent.vue';
export default {
  components: { ShiftAssignCalender, ShiftTableComponent },
  data() {
    return {
      shifts: [],
    };
  },
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    userData: {
      type: Object,
      default: () => ({}),
    },
  },
  created() {
    this.getShifts();
  },
  methods: {
    getShifts() {
      this.axios.get('/active-shifts-for-relation').then(({ data }) => {
        this.shifts = data.data;
      });
    },
    closeModal() {
      this.$emit('closeModal');
    },
  },
};
</script>
